import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=a98e8ce6&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98e8ce6",
  null
  
)

export default component.exports